import { hasKey, t } from '../i18n';

/**
 * Presentation for the server's error codes.
 *
 * The server sends a stable machine code plus an English fallback message. The
 * code is the contract; the translation is looked up as `err.<code>` in the
 * current language's table.
 *
 * A code with no entry falls through to the server's own message instead of
 * showing the player a key. That path is expected to be hit: the server can ship
 * a new validation code before the client has a translation for it, and an
 * English sentence beats `err.invalid_something`.
 */
export function localise(code: string, fallback: string): string {
  const key = `err.${code}`;
  if (hasKey(key)) return t(key);
  return fallback || t('err.unexpected');
}

/**
 * Presentation for the handshake's reason an account may not play. Same rule:
 * `blocked.<reason>`, with the server's message as the fallback.
 */
export function localiseBlocked(reason: string | undefined, fallback: string): string {
  if (reason) {
    const key = `blocked.${reason}`;
    if (hasKey(key)) return t(key);
  }
  return fallback || t('blocked.default');
}
